import * as authEvents from "../../store/events/auth";
import AccessDeniedView from "../../views/auth/AccessDeniedView";
import EditAddressView from "../../views/profile/EditAddressView";
import EditContactEmailView from "../../views/profile/EditContactEmailView";
import EditContactPhoneView from "../../views/profile/EditContactPhoneView";
import HomeView from "../../views/HomeView";
import { IAM_EXCHANGE_TOKEN_PARAM_ID } from "../../config/auth";
import InboxView from "../../views/profile/InboxView";
import MaintenanceView from "../../views/MaintenanceView";
import { NoContentView } from "../../views/error";
import PendingVerification from "../Loading/PendingVerification";
import ProfileView from "../../views/profile/ProfileView";
import React from "react";
import TaxSummaryView from "../../views/profile/TaxSummaryView";
import { connect } from "react-redux";
import { isInMaintenanceWindow } from "../../utils/maintenance";
import {
	isStringOfLength
} from "@pheaa/channels-component-library";
import useInterval from "../../utils/hooks/useInterval";
import withSessionManager from "../../utils/withSessionManager";
import withViewEnhancements from "../../utils/withViewEnhancements";
import {
	Outlet,
	Route,
	Routes,
	useLocation,
	useNavigate,
} from "react-router-dom";

// Remember to update /lib/consumer-guaranty-portal-routes.js with any changes to route paths;
const routeMap = [{
	route: "",
	title: "Home",
	view: HomeView
}, {
	route: "profile",
	title: "Profile",
	view: ProfileView
}, {
	route: "profile/edit-address",
	title: "Edit Address",
	view: EditAddressView
}, {
	route: "profile/edit-contact-email",
	title: "Edit Contact Email",
	view: EditContactEmailView
}, {
	route: "profile/edit-contact-phone",
	title: "Edit Contact Phone",
	view: EditContactPhoneView
}, {
	route: "inbox",
	title: "Inbox",
	view: InboxView
}, {
	route: "inbox/tax-summary/:taxSummaryId",
	title: "Tax Summary Statement",
	view: TaxSummaryView
}, {
	route: "*",
	title: "Page Not Found",
	view: NoContentView
}];

const RouteManager = props => {

	let returnElem = null;

	const {
		isAppInitialized,
		isAuthenticated,
		isPendingTokenVerification,
		maintenance,
		verifyTokens
	} = props;

	const location = useLocation();
	const navigate = useNavigate(); // Intentionally selected hook useNavigate over useNavigateQSA here;
	const [isInStaticMaintMode, setIsInStaticMaintMode] = React.useState(false);

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	React.useEffect(() => {
		const { pathname, search } = location;
		const queryParameters = new URLSearchParams(search);
		// Clean up exchange token paramter;
		if (queryParameters.has(IAM_EXCHANGE_TOKEN_PARAM_ID)) {
			queryParameters.delete(IAM_EXCHANGE_TOKEN_PARAM_ID);
			navigate({ pathname, search: queryParameters.toString() }, { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		setIsInStaticMaintMode(maintenance.enabled || isInMaintenanceWindow(maintenance.schedule));
	}, [maintenance]);

	useInterval(() => {
		const isStillInMaintWindow = maintenance.enabled || isInMaintenanceWindow(maintenance.schedule);

		if (isInStaticMaintMode && !isStillInMaintWindow) {
			verifyTokens(true, true);
		}

		setIsInStaticMaintMode(isStillInMaintWindow);
	}, 1000);

	const mapRoutes = () => {
		return routeMap.map(routeData => {
			const routes = [routeData.route];
			const ViewElement = withSessionManager(withViewEnhancements(routeData.view, routeData.title));
			isStringOfLength(routeData.routeAlias) && routes.push(routeData.routeAlias);
			return routes.map(route => (
				<Route
					element={<ViewElement title={routeData.title} />}
					key={route}
					path={route}
				/>
			));
		});
	};

	if (!isAppInitialized) {
		returnElem = <Route element={<PendingVerification />} path="*" />;
	} else if (isPendingTokenVerification) {
		returnElem = <Route element={<PendingVerification />} path="*" />;
	} else if (isInStaticMaintMode) {
		returnElem = <Route element={<MaintenanceView />} path="*" />;
	} else if (isAuthenticated) {
		returnElem = mapRoutes();
	} else {
		returnElem = (
			<Route element={<AccessDeniedView />} path="*" />
		);
	}

	return (
		<Routes>
			<Route path="/*" element={<Outlet />}>
				{returnElem}
			</Route>
		</Routes>
	);
};

const mapStateToProps = state => {
	return {
		isAppInitialized: state.common.isAppInitialized,
		isAuthenticated: state.auth.isAuthenticated,
		isPendingTokenVerification: state.auth.isPendingTokenVerification,
		maintenance: state.common.appConfig.maintenance,
	};
};

const mapDispatchToProps = dispatch => ({
	verifyTokens: (getProfileOnSuccess, getInboxOnSuccess) => dispatch(authEvents.verifyTokens(getProfileOnSuccess, getInboxOnSuccess))
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteManager);